// Keeps track of the access token lifetime, so the data service can refresh it without the React tree

type TokenRefresher = () => Promise<string | undefined>;

// The token is renewed this long before it actually expires
const REFRESH_MARGIN_MS = 10 * 60 * 1000;
// Used when the lifetime can not be read out of the token
const DEFAULT_LIFETIME_MS = 45 * 60 * 1000;

let refresher: TokenRefresher | undefined;
let expiresAt = 0;

export const registerTokenRefresher = (fn: TokenRefresher | undefined) => {
    refresher = fn;
};

const readExpiration = (token: string): number | undefined => {
    try {
        const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const { exp } = JSON.parse(window.atob(payload));
        return typeof exp === "number" ? exp * 1000 : undefined;
    } catch {
        return undefined;
    }
};

export const setTokenExpiration = (token: string, expiresInSeconds?: number) => {
    expiresAt = readExpiration(token)
        ?? (expiresInSeconds ? Date.now() + expiresInSeconds * 1000 : Date.now() + DEFAULT_LIFETIME_MS);
};

export const isTokenExpiring = (): boolean => {
    return !!refresher && Date.now() > expiresAt - REFRESH_MARGIN_MS;
};

export const refreshAccessToken = (): Promise<string | undefined> => {
    return refresher ? refresher() : Promise.resolve(undefined);
};
